import { useEffect, useMemo } from 'react'
import type { createListQueryPersistence } from '@/utils/list-query-persistence.ts'
import type { PageTableSearch } from './use-page-table.ts'

export function usePersistedListQuery<T extends PageTableSearch>({
  persistence,
  raw,
  accountId,
  navigate
}: {
  persistence: ReturnType<typeof createListQueryPersistence<T>>
  raw: Partial<T>
  accountId: number
  navigate: (options: {
    replace?: boolean
    search: Partial<T> | ((previous: Partial<T>) => Partial<T>)
  }) => Promise<void>
}) {
  // 稳定查询引用，避免无关渲染反复写缓存或覆盖表单输入。
  const search = useMemo(() => persistence.schema.parse(raw), [persistence, raw])
  useEffect(() => {
    persistence.store.getState().remember(accountId, search)
  }, [persistence, accountId, search])

  const navigateSearch = ({
    search: next,
    ...options
  }: {
    replace?: boolean
    search: Partial<T> | ((previous: T) => Partial<T>)
  }) =>
    navigate({
      ...options,
      search: (previous) => (typeof next === 'function' ? next(persistence.schema.parse(previous)) : next)
    })
  return { search, navigateSearch }
}
